import React from "react";
import { Route } from "react-router-dom";
import EducationHub from "../components/index";

const EducationHubRoutes = () => {
  return (
    <>
      <Route path="/education-hub" element={<EducationHub />} /> 
    </>
  );
};

export default EducationHubRoutes;
